import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';

import TabBankSummary from '../TabBankSummary';
import PayBankDetail from './PayBankDetail';
import { resizeComponent } from '../../../utils';
import { IsEnglish } from '../../../utils/language';
import styles from '../../../styles/bankBalance.module.css';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "60px"
        },
        textAlign: 'left',
        float: 'left',
        marginTop: '12px'
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "190px"
        },
        float: 'left',
        marginTop: '12px'
    },
    appBar: {
        position: 'relative',
    },
    accordionSummary: {
        color: 'var(--color2) !important'
    },
    iconExpand: {
        color: 'var(--color2) !important'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AllPayBankBalance(props) {
    const classes = useStyles();

    const [dataBank, setDataBank] = React.useState(null);
    const [dataDetailBank, setDataDetailBank] = React.useState(null);
    const [expanded, setExpanded] = React.useState(null);
    const [title, setTitle] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const { data } = props;

    useEffect(() => {
        loadData();
        resizeComponent('div[data-id=headerAllPayBankBalance]', '#divAllPayBankBalance');
    }, []);

    const loadData = () => {
        setDataBank(data);
    }

    const handleAccordion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleOpenDetail = (event, year, description, bankTypeId) => {
        event.preventDefault();
        event.stopPropagation();
        var bank = dataBank.filter(item => item.year === year && item.bankTypeId == bankTypeId)[0];
        if (bank !== undefined) {
            setDataDetailBank(bank.bankDetail);
        }
        setTitle(`${year} - ${description}`)
        setOpen(true);
    };

    const handleCloseClick = () => {
        setOpen(false);
    }

    return (
        <div id="divAllPayBankBalance" className={styles.rootBankBalance}>
            {dataBank != null && dataBank.map((obj, index) =>
                <React.Fragment key={index}>
                    <Accordion className={classes.accordionSummary} expanded={expanded === index} onChange={handleAccordion(index)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={classes.iconExpand} />}
                            aria-controls={`panel2${index}-content`}
                            id={`panel${index}-header`}
                        >
                            <div className={classes.firstCell}>{obj.year}</div>
                            <div className={classes.secondCell}>{obj.bankTypeId + ' - ' + (IsEnglish() ? obj.bankEn : obj.bankFr)}</div>
                            <div className={classes.thirdCell}>
                                <IconButton edge="start" color="inherit" onClick={(event) => handleOpenDetail(event, obj.year, IsEnglish() ? obj.bankEn : obj.bankFr, obj.bankTypeId)} aria-label="close">
                                    <ListAltIcon />
                                </IconButton>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TabBankSummary data={dataBank.filter(item => item.year == obj.year)} typeSolde={0} />
                        </AccordionDetails>
                    </Accordion>
                </React.Fragment>
            )}
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerPayBankDetail">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {title}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="detailPayBankDetail">
                    <PayBankDetail data={dataDetailBank} />
                </div>
            </Dialog>
        </div>
    );
}